module.exports = __webpack_public_path__ + "images/menu-contents.svg?25e4a038bdb3ea66e1379b1b96980737";